import { themedStyled } from 'common/styles/styletron.theme';

export const InputBoxContainer = themedStyled<
  'div',
  { $disabled?: boolean; $error?: boolean }
>('div', ({ $disabled, $error, $theme }) => ({
  display: 'flex',
  padding: '5px 14px',
  borderColor: $error ? $theme.colors.borderNegative : '',
  borderStyle: $error ? 'solid' : 'none',
  borderWidth: '2px',
  backgroundColor: $error
    ? $theme.colors.backgroundLightNegative
    : $disabled
    ? '#F6F6F6'
    : '#EEEEEE',
  borderRadius: '8px',
  minHeight: '44px',
  alignItems: 'center',
}));

export const TagPill = themedStyled('div', {
  margin: '0.75rem 0.5rem',
  borderRadius: '8px',
  boxShadow: '0 2px 12px rgb(14 31 80 / 10%)',
  padding: '0.4rem 0.6rem',
  backgroundColor: 'white',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const TagContainer = themedStyled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  flex: 1,
});

export const RawInputTag = themedStyled('input', {
  backgroundColor: 'transparent',
  height: 'fit-content',
  margin: '0px',
  outline: 'none',
  border: 'none',
});
